import { render } from "./DownloadView.vue?vue&type=template&id=1006b400"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"

import "@/assets/css/views/DownloadView.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__